import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import createRootReducer from './combineReducers';
import { composeWithDevTools } from 'redux-devtools-extension';

export default () => {
    const store = createStore(createRootReducer(), composeWithDevTools(applyMiddleware(thunk)));
    return { store };
};
